export default __webpack_public_path__ + "static/customer-service-management_app_light-cc467c06ff0b2c7f70e9d83531eba6c51051c5cec1b04cff0f22bc44f44f89bb.svg";